<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('company.upload_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="company-import-submit"
                :loading="processing"
                :disabled="is_admin_section ? fileList.length == 0 || association == null : fileList.length == 0"
                @click="handleSubmit"
            >
                {{ $t('company.upload_modal.submit') }}
            </a-button>
        </template>
        <a-upload-dragger
            name="file"
            data-cy="company-import-drag"
            @remove="handleRemove"
            :file-list="fileList"
            :multiple="true"
            :before-upload="beforeUpload"
        >
            <p class="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p class="ant-upload-text">{{ $t('company.upload_modal.body') }}</p>
            <p class="ant-upload-hint">{{ $t('company.upload_modal.hint') }}</p>
        </a-upload-dragger>
        <div v-if="is_admin_section" class="w-1/2 pr-4 mt-2">
            <ui-label data-cy="admin-company-association-label">{{ $t('company.general.association') }}</ui-label>
            <a-select
                data-cy="admin-company-import-association-select"
                :placeholder="$t('company.general.association')"
                class="mt-2"
                show-search
                style="width: 100%"
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="handleFilterChange"
                :allowClear="true"
            >
                <a-select-option v-for="(value, index) in associationList" :key="index" :value="index">
                    {{ value.name }}
                </a-select-option>
            </a-select>
        </div>
    </a-modal>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
    components: { UiLabel, InboxOutlined },
    data() {
        return {
            modal_visible: false,
            fileList: [],
            fileLimit: -3,
            association: null,
            associationList: [],
        };
    },
    mounted() {
        if (this.is_admin_section) {
            this.$http
                .get('/api/admin/list-associations')
                .then((response) => {
                    this.associationList = response.data.data;
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVACIM01' }),
                    });
                });
        }
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        is_admin_section: {
            type: Boolean,
            default: false,
        },
        association_id: {
            type: String,
            default: '',
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.association = null;
            this.fileList = [];
            this.modal_visible = true;
        },
        handleSubmit() {
            const { fileList } = this;
            const formData = new FormData();
            if (this.association == null) {
                formData.append('association_id', this.association_id);
            } else {
                formData.append('association_id', this.association);
            }

            fileList.forEach((file) => {
                formData.append('files[]', file);
            });
            this.$emit('formSubmit', formData);
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            const isCSV = file.type === 'text/csv';
            const isXSL = file.type === 'application/vnd.ms-excel';
            const isXSLX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (isCSV || isXSL || isXSLX) {
                if (this.fileList.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.fileList = [...this.fileList, file].slice(this.fileLimit);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'CSV, XSL or XSLX' }),
                });
            }
            return false;
        },
        handleFilterChange(value) {
            this.association = null;

            if (value != undefined) {
                this.association = this.associationList[value].id;
            }
        },
        filterOption(input, option) {
            return option.children()[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
    },
};
</script>
